import {Aggregation, AggregationOption} from '__generated__/__types__';
import CategoryFilterItem from '@/_application/modules/categories/components/category-filter/category-filter-item';
import {filterAttributeCodeValueType} from '@/framework/static/filter-attribute-code-value-type';
import {useProductListView} from '@/_application/modules/products/provider/product-list-view.provider';
import CategoryFilterPrice from '@/_application/modules/categories/components/category-filter/category-filter-price/category-filter-price';
import rangeMap from '@/lib/range-map';
import CategoryFilterItemLoader from '@/_application/modules/categories/components/category-filter/category-filter-item-loader';
import {ProductBlockEnum} from '@/_application/modules/products/model/product-block.enum';

interface IProps {
    aggregations: readonly Aggregation[];
    isLoading: boolean;
    onFilterChange: (values: string[] | string, attributeCode: string) => void;
}

function CategoryFilter({aggregations, isLoading, onFilterChange}: Readonly<IProps>) {
    const {filter} = useProductListView();

    return (
        <div
            className="mt-5 flex flex-wrap items-center justify-start gap-2"
            id={ProductBlockEnum.PRODUCT_CATEGORY_BLOCK}>
            {isLoading
                ? rangeMap(5, i => <CategoryFilterItemLoader key={i} />)
                : aggregations?.map(item => {
                      const filterValuesByAttributeCode = (filter as any)[item.attribute_code];
                      if (!item.options?.length) {
                          return null;
                      }
                      const options = item.options as AggregationOption[];

                      switch (true) {
                          case item.attribute_code === 'price': {
                              const defaultValueFrom = filterValuesByAttributeCode?.from;
                              const defaultValueTo = filterValuesByAttributeCode?.to;

                              return (
                                  <CategoryFilterPrice
                                      key={item.attribute_code}
                                      label={item.label as string}
                                      options={options}
                                      defaultValue={[parseInt(defaultValueFrom), parseInt(defaultValueTo)]}
                                      onSave={values => onFilterChange(values, item.attribute_code)}
                                  />
                              );
                          }
                          case filterAttributeCodeValueType.filterMatchType.includes(item.attribute_code): {
                              const defaultValue = filterValuesByAttributeCode?.match;
                              const defaultOption = options.filter(option => option?.value === defaultValue);
                              return (
                                  <CategoryFilterItem
                                      key={item.attribute_code}
                                      label={item.label as string}
                                      options={options}
                                      defaultValue={defaultOption}
                                      onSave={values => onFilterChange(values, item.attribute_code)}
                                      attributeCode={item.attribute_code}
                                      isMulti={false}
                                  />
                              );
                          }
                          case filterAttributeCodeValueType.filterEqualType.includes(item.attribute_code): {
                              const defaultValues = filterValuesByAttributeCode?.in;
                              const defaultOptions = item.options?.filter(option =>
                                  defaultValues?.includes(option?.value),
                              );
                              return (
                                  <CategoryFilterItem
                                      key={item.attribute_code}
                                      label={item.label as string}
                                      options={options}
                                      defaultValue={defaultOptions}
                                      onSave={values => onFilterChange(values, item.attribute_code)}
                                      attributeCode={item.attribute_code}
                                  />
                              );
                          }
                          default:
                              return null;
                      }
                  })}
        </div>
    );
}

export default CategoryFilter;
